const RM_FORMATTER = new Intl.NumberFormat("en-MY", {
  style: "currency",
  currency: "MYR",
  currencyDisplay: "narrowSymbol",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Formats a numeric value as Malaysian Ringgit (RM), e.g. 1234.5 -> "RM 1,234.50".
 */
export function formatCurrency(value: number): string {
  return `RM ${RM_FORMATTER.format(value).replace(/^RM\s?/, "")}`;
}

/**
 * Safely formats a possibly invalid value as RM currency, returning `fallback`
 * when the value cannot be parsed into a finite number.
 */
export function safeFormatCurrency(
  value: unknown,
  fallback = "RM 0.00",
): string {
  const amount = typeof value === "string" ? Number(value) : value;

  if (typeof amount !== "number" || !Number.isFinite(amount)) {
    return fallback;
  }

  return formatCurrency(amount);
}
